export interface Character {
  id: string;
  name: string;
  role: string;
  category: string;
  tag: string;
  quote: string;
  intro: string;
  detail: string;
  statLabel: string[];
  statValue: number[];
  image: string;
}

export interface Cp {
  id: string;
  name: string;
  type: string;
  member: string;
  status: string;
  desc: string;
  emoji: string;
  tone: string;
}

export interface TimelineStep {
  id: string;
  range: string;
  title: string;
  tag: string;
  desc: string;
  image: string;
}

export interface Article {
  id: string;
  title: string;
  summary: string;
  tag: string;
  read: string;
  image: string;
}

export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const siteName = "恋爱辅助器漫画角色站";

export const story = {
  title: "一部关于误会的校园恋爱喜剧",
  highlight:
    "元气少女 + 高冷学霸 + 一台会吐槽的恋爱辅助器，组成这个冬天最治愈的双向奔赴。",
  paragraphs: [
    "《恋爱辅助器》是一部以「恋爱攻略」为主题的校园恋爱喜剧。元气少女苏念安意外收到一台自称「恋爱辅助器」的神秘掌上装置，系统拟人化为软萌又毒舌的小精灵「阿柒」。阿柒能实时给出好感度提示、心动检测与攻略建议，苏念安便带着它向全校公认的高冷学霸陆之遥发起了一场「惊心动魄」的攻略战。",
    "可辅助器不是万能的——数据会出错、攻略会翻车，一场场啼笑皆非的意外，让原本毫无交集的两人越走越近。这既是一部关于误会与成长的故事，也是一段从「假装攻略」到「真心沦陷」的治愈系恋爱物语。",
  ],
  tags: ["校园恋爱", "欢喜冤家", "治愈系", "双向奔赴"],
  stat: [
    { label: "连载话数", value: "72+" },
    { label: "主线CP", value: "遥念CP" },
    { label: "主要角色", value: "5 位" },
    { label: "作品类型", value: "恋爱喜剧" },
  ],
};

export const characters: Character[] = [
  {
    id: "sunianan",
    name: "苏念安",
    role: "女主 · 元气攻略派",
    category: "主角",
    tag: "元气少女",
    quote: "先定一个小目标，把他攻略到脸红！",
    intro:
      "活泼跳脱的元气少女，行动力爆表，脑回路清奇。为了「验证」恋爱辅助器而向高冷学霸陆之遥发起攻略，结果越陷越深。",
    detail:
      "校园里的气氛担当，永远精力充沛。她得到恋爱辅助器后，将其视为一场有趣的「恋爱实验」，却在一路的试探与碰撞里，逐渐把玩笑变成了真心。外表大大咧咧，内心却极其柔软，是连接整个故事的关键纽带。",
    statLabel: ["元气值", "行动力", "恋爱技巧"],
    statValue: [96, 98, 42],
    image:
      "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20cheerful%20energetic%20schoolgirl%20with%20shoulder-length%20orange%20hair%20and%20bright%20amber%20eyes%2C%20warm%20smile%2C%20casual%20student%20outfit%2C%20soft%20cream%20background%2C%20coral%20peach%20palette%2C%20clean%20anime%20illustration%20style%2C%20high%20detail&width=600&height=760&seq=char-nian-01&orientation=portrait",
  },
  {
    id: "luzhiyao",
    name: "陆之遥",
    role: "男主 · 高冷学霸",
    category: "主角",
    tag: "高冷学霸",
    quote: "别乱按那个破机器，会出事的。",
    intro:
      "冷静理性的学霸男神，表面拒人千里，实则被苏念安的莽撞搅得心绪不宁，是全作最先动心却不自知的人。",
    detail:
      "成绩常年第一的校园男神，习惯与人群保持距离。恋爱辅助器对他的「好感度」一直居高不下，让他百思不得其解。随着苏念安一次次「翻车式」攻略，他冷硬的外壳被一点点撬开，成为故事里最明显的「口嫌体正直」担当。",
    statLabel: ["冷静值", "口嫌体", "心动指数"],
    statValue: [95, 100, 88],
    image:
      "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20cool%20handsome%20top%20student%20with%20neat%20dark%20hair%20and%20calm%20dark%20eyes%2C%20white%20school%20uniform%20shirt%2C%20soft%20cream%20background%2C%20subtle%20warm%20lighting%2C%20clean%20anime%20illustration%20style%2C%20high%20detail&width=600&height=760&seq=char-yao-01&orientation=portrait",
  },
  {
    id: "aqi",
    name: "阿柒",
    role: "恋爱辅助器 · 毒舌精灵",
    category: "系统",
    tag: "软萌毒舌",
    quote: "宿主，你的攻略又双叒翻车了。",
    intro:
      "恋爱辅助器的拟人化精灵，软萌又毒舌，最爱吐槽宿主操作，掌握全部心动数据却守口如瓶。",
    detail:
      "一台会飞的小圆球精灵，声音软糯、吐槽犀利，是整个故事的「人形弹幕」。它能读取好感度、监测心动值，却总在最关键的时刻掉链子。阿柒的真实来历是贯穿全作的核心伏笔，随着「定情篇」推进逐渐揭晓。",
    statLabel: ["毒舌度", "呆萌值", "隐藏情报"],
    statValue: [82, 90, 100],
    image:
      "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20cute%20tiny%20round%20elf%20mascot%20with%20big%20sparkling%20eyes%20and%20small%20wings%2C%20soft%20glow%2C%20dreamy%20cream%20background%2C%20coral%20accent%20lighting%2C%20adorable%20chibi%20anime%20style%2C%20high%20detail&width=600&height=760&seq=char-qi-01&orientation=portrait",
  },
  {
    id: "guyanxiu",
    name: "顾言修",
    role: "男二 · 温柔学长",
    category: "配角",
    tag: "温柔守护",
    quote: "只要她开心，我退到旁边也甘愿。",
    intro:
      "温柔体贴的青梅竹马学长，默默守护苏念安多年，是故事里最让人心疼的守护线。",
    detail:
      "从小和苏念安一起长大的邻家学长，永远带着治愈的微笑。他看得懂苏念安每一次雀跃与失落，却始终把喜欢藏在身后。作为主CP感情线最温柔的对照，他的克制与成全，也为故事增添了真实而细腻的情感层次。",
    statLabel: ["温柔值", "隐忍度", "存在感"],
    statValue: [99, 88, 66],
    image:
      "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20gentle%20warm%20senior%20student%20with%20soft%20brown%20hair%20and%20kind%20eyes%2C%20beige%20cardigan%20over%20shirt%2C%20soft%20cream%20background%2C%20warm%20peach%20lighting%2C%20clean%20anime%20illustration%20style%2C%20high%20detail&width=600&height=760&seq=char-xiu-01&orientation=portrait",
  },
  {
    id: "linzhixia",
    name: "林知夏",
    role: "女二 · 理论闺蜜",
    category: "配角",
    tag: "恋爱理论家",
    quote: "理论我都懂，实操嘛……下次再说。",
    intro:
      "苏念安的最佳闺蜜，满口恋爱金句的「理论大师」，实际却是母胎单身，反差感十足。",
    detail:
      "自带眼镜的冷静系少女，是苏念安的军师兼吐槽担当。她能把每段恋爱关系分析得头头是道，轮到自己却一窍不通。林知夏的存在让主角团的对话永远妙语连珠，也承包了大量经典名场面。",
    statLabel: ["毒舌值", "理论值", "实操值"],
    statValue: [90, 96, 18],
    image:
      "https://readdy.ai/api/search-image?query=anime%20portrait%20of%20a%20smart%20confident%20girl%20with%20glasses%20and%20neat%20bob%20hair%2C%20holding%20a%20book%2C%20soft%20cream%20background%2C%20warm%20coral%20accents%2C%20clean%20anime%20illustration%20style%2C%20high%20detail&width=600&height=760&seq=char-xia-01&orientation=portrait",
  },
];

export const cps: Cp[] = [
  {
    id: "yaonian",
    name: "遥念CP",
    type: "主线CP",
    member: "苏念安 × 陆之遥",
    status: "双向奔赴 · 已表白",
    desc: "从「假装攻略」到「真心沦陷」的欢喜冤家主线，堪称全书最甜的双向奔赴。阿柒的好感度数据，早已悄悄暴露了两颗靠近的心。",
    emoji: "❤️",
    tone: "primary",
  },
  {
    id: "guard",
    name: "守护线",
    type: "单恋守护",
    member: "顾言修 → 苏念安",
    status: "默默守护中",
    desc: "温柔学长的克制与成全。他把喜欢藏在每一次恰到好处的关心里，为主角团的情感世界增添一层细腻而真实的底色。",
    emoji: "🌙",
    tone: "accent",
  },
  {
    id: "theory",
    name: "吐槽CP",
    type: "友情向",
    member: "林知夏 × 阿柒",
    status: "理论 vs 实操",
    desc: "恋爱理论大师与毒舌系统之间的互怼日常，承包了全作大量名场面，也是支线笑点的重要来源。",
    emoji: "💬",
    tone: "secondary",
  },
];

export const relationship = [
  {
    group: "核心情感三角",
    nodes: [
      { name: "苏念安", note: "女主", color: "primary" },
      { name: "陆之遥", note: "男主", color: "primary" },
      { name: "顾言修", note: "守护线", color: "accent" },
    ],
    lines: [
      { a: "苏念安", b: "陆之遥", text: "主线CP · 双向奔赴", kind: "strong" },
      { a: "顾言修", b: "苏念安", text: "单恋守护", kind: "weak" },
    ],
  },
  {
    group: "闺蜜与军师",
    nodes: [
      { name: "林知夏", note: "女二", color: "secondary" },
      { name: "苏念安", note: "女主", color: "primary" },
    ],
    lines: [{ a: "林知夏", b: "苏念安", text: "闺蜜 · 恋爱军师", kind: "strong" }],
  },
  {
    group: "系统与宿主",
    nodes: [
      { name: "阿柒", note: "辅助器", color: "secondary" },
      { name: "苏念安", note: "宿主", color: "primary" },
      { name: "陆之遥", note: "观察对象", color: "primary" },
    ],
    lines: [
      { a: "阿柒", b: "苏念安", text: "宿主契约", kind: "strong" },
      { a: "阿柒", b: "陆之遥", text: "好感度监测", kind: "weak" },
    ],
  },
];

export const timeline: TimelineStep[] = [
  {
    id: "s1",
    range: "第 1 - 10 话",
    title: "初遇篇 · 从天而降的辅助器",
    tag: "相遇",
    desc: "一台会飞的恋爱辅助器砸进苏念安的生活，她顺势把攻略高冷学霸陆之遥当成了「恋爱实验」的开端。",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20surprised%20cheerful%20girl%20catching%20a%20small%20glowing%20flying%20gadget%20in%20a%20sunny%20school%20courtyard%2C%20warm%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=900&height=560&seq=timeline-1-01&orientation=landscape",
  },
  {
    id: "s2",
    range: "第 11 - 25 话",
    title: "攻略篇 · 好感度忽上忽下",
    tag: "试探",
    desc: "各种搞笑攻略轮番上演，苏念安的「神操作」屡战屡败，陆之遥的好感度却在这种鸡飞狗跳里悄悄攀升。",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20flustered%20cheerful%20girl%20trying%20awkward%20flirty%20poses%20in%20front%20of%20a%20confused%20cool%20boy%20in%20a%20classroom%2C%20comedy%20mood%2C%20warm%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=900&height=560&seq=timeline-2-01&orientation=landscape",
  },
  {
    id: "s3",
    range: "第 26 - 40 话",
    title: "心动篇 · 最先动心的那个人",
    tag: "心动",
    desc: "陆之遥在一次次意外的独处里逐渐沦陷，明明心动值早已爆表，却还嘴硬不认，成为全书最甜的「口嫌体正直」。",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20cool%20boy%20with%20blushing%20cheeks%20awkwardly%20avoiding%20eye%20contact%20with%20a%20smiling%20girl%20during%20a%20quiet%20sunset%20moment%20at%20school%2C%20warm%20romantic%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=900&height=560&seq=timeline-3-01&orientation=landscape",
  },
  {
    id: "s4",
    range: "第 41 - 55 话",
    title: "误会篇 · 辅助器数据出错",
    tag: "波折",
    desc: "阿柒的一次数据故障制造了巨大误会，让两人好不容易拉近的距离再度拉开，感情线迎来全作最大的波折。",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20sad%20girl%20and%20a%20cold%20boy%20standing%20apart%20in%20rain%20under%20an%20umbrella%2C%20moody%20soft%20lighting%2C%20muted%20warm%20tones%2C%20dramatic%20emotional%20manga%20scene%2C%20high%20detail&width=900&height=560&seq=timeline-4-01&orientation=landscape",
  },
  {
    id: "s5",
    range: "第 56 话起",
    title: "定情篇 · 真相大白，双向奔赴",
    tag: "告白",
    desc: "误会解开，阿柒的真实秘密浮出水面。陆之遥终于放下高冷外壳坦诚告白，故事走向确定关系后的甜蜜日常。",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20happy%20couple%20holding%20hands%20under%20blooming%20cherry%20trees%20at%20golden%20dusk%2C%20heartfelt%20confession%20mood%2C%20warm%20coral%20peach%20palette%2C%20romantic%20clean%20manga%20style%2C%20high%20detail&width=900&height=560&seq=timeline-5-01&orientation=landscape",
  },
];

export const articles: Article[] = [
  {
    id: "a1",
    title: "恋爱辅助器·角色全解析：从女主到阿柒一次看懂",
    summary: "五位核心角色的定位、性格关键词与成长线一次讲清，帮你快速建立完整的人物认知图谱。",
    tag: "角色解析",
    read: "8 分钟",
    image:
      "https://readdy.ai/api/search-image?query=anime%20group%20illustration%20of%20five%20colorful%20manga%20characters%20standing%20together%20in%20a%20row%2C%20cheerful%20school%20background%2C%20warm%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=800&height=500&seq=article-1-01&orientation=landscape",
  },
  {
    id: "a2",
    title: "盘点《恋爱辅助器》五大名场面，笑到停不下来",
    summary: "从翻车式攻略到理论闺蜜的毒舌暴击，五场最经典的爆笑桥段一次性带你看个够。",
    tag: "名场面",
    read: "6 分钟",
    image:
      "https://readdy.ai/api/search-image?query=anime%20comedy%20illustration%20of%20a%20panicking%20girl%20with%20steam%20coming%20off%20her%20head%20chasing%20a%20running%20cat%2C%20explosive%20comic%20effects%2C%20warm%20coral%20peach%20palette%2C%20energetic%20clean%20manga%20style%2C%20high%20detail&width=800&height=500&seq=article-2-01&orientation=landscape",
  },
  {
    id: "a3",
    title: "遥念CP感情线全梳理：他们怎么一步步走向彼此",
    summary: "从初遇、试探、心动到误会与告白，主线CP的感情推进节点与对应话数完整时间线。",
    tag: "CP时间线",
    read: "9 分钟",
    image:
      "https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20couple%20walking%20together%20through%20a%20night%20festival%20with%20warm%20lantern%20lights%2C%20romantic%20mood%2C%20warm%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=800&height=500&seq=article-3-01&orientation=landscape",
  },
  {
    id: "a4",
    title: "阿柒人物档案：这个毒舌系统到底藏了什么秘密",
    summary: "软萌外表下的核心伏笔，阿柒的真实来历、隐藏情报与「定情篇」的关键走向深度剖析。",
    tag: "人物档案",
    read: "7 分钟",
    image:
      "https://readdy.ai/api/search-image?query=anime%20mystery%20illustration%20of%20a%20glowing%20round%20elf%20mascot%20surrounded%20by%20floating%20gear%20and%20digital%20data%20particles%2C%20soft%20dramatic%20light%2C%20warm%20coral%20peach%20palette%2C%20clean%20manga%20style%2C%20high%20detail&width=800&height=500&seq=article-4-01&orientation=landscape",
  },
];

export const faqs: Faq[] = [
  {
    id: "f1",
    q: "《恋爱辅助器》目前更新到第几话了？",
    a: "截至目前连载到第 72 话，主线「定情篇」仍在更新中，官方每周固定更新，建议关注官方平台获取最新话数。",
  },
  {
    id: "f2",
    q: "《恋爱辅助器》在哪里可以看？",
    a: "作品在主流漫画平台均可阅读，搜索「恋爱辅助器」即可。为避免剧透，追更时请留意章节顺序与更新状态。",
  },
  {
    id: "f3",
    q: "苏念安和陆之遥最后在一起了吗？",
    a: "故事进入「定情篇」后，两人的感情线已明确走向双向奔赴，陆之遥正式表白，后续剧情围绕确定关系后的日常展开。",
  },
  {
    id: "f4",
    q: "《恋爱辅助器》有实体单行本吗？",
    a: "目前官方已推出电子版单行本，实体版是否发售请以官方公告为准，暂不建议相信非官方渠道。",
  },
  {
    id: "f5",
    q: "阿柒的真实身份是什么？",
    a: "阿柒的真实来历是故事的核心伏笔之一，随着「定情篇」推进逐渐揭晓，详细设定建议从漫画原篇中寻找答案。",
  },
];

export const testimonials = [
  {
    name: "遥念CP粉",
    role: "追更读者",
    text: "人物关系图谱整理得太清楚了，追番再也不用翻聊天记录找人物了！",
  },
  {
    name: "柚子茶",
    role: "忠实读者",
    text: "感情线时间轴很完整，从初遇到定情每一步都有对应话数，太贴心了。",
  },
  {
    name: "新读者阿夏",
    role: "入坑萌新",
    text: "阿柒的人物档案写得很有趣，把伏笔都串起来了，看完直接上头。",
  },
];